<template>
    <div class="navbar">
        <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container"
                   @toggleClick="toggleSideBar"/>

        <breadcrumb id="breadcrumb-container" class="breadcrumb-container"/>

        <div class="right-menu">
            <div class="pointer right-menu-item mr12" v-if="!isErrPage">
                <el-badge :value="messageCount" :hidden="messageCount<=0" class="item badge-con" :max="99"
                v-matomo="{behaviorCategory: '系统功能', event: '点击',  name: '消息中心' }"
                @click.native="showMessageDrawer">
                    <el-tooltip class="" effect="dark" content="消息中心" placement="bottom">
                        <span class="iconfont icon-jt-notice"></span>
                    </el-tooltip>
                </el-badge>
            </div>

            <div class="pointer right-menu-item mr12"
            v-matomo="{behaviorCategory: '系统功能', event: '点击',  name: '离线下载中心' }"
            @click="showDownloadPage" v-if="!isErrPage">
                <el-tooltip class="" effect="dark" content="离线下载中心" placement="bottom">
                    <span class="iconfont icon-jt-download"></span>
                    <!--<span class="font12px">离线下载中心</span>-->
                </el-tooltip>
            </div>
            <div class="pointer right-menu-item" v-matomo="{behaviorCategory: '系统功能', event: '点击',  name: '处理队列' }" @click="()=>seeWorkOrderQueueModal()" v-if="!isErrPage">
                <el-tooltip class="" effect="dark" content="处理队列" placement="bottom">
                    <!-- <img width="20" src="~@/assets/img/queue.png" /> -->
                    <span class="iconfont icon-jt-renwuzhongxin"></span>
                </el-tooltip>
            </div>
            <div class="right-menu-item" v-if="!isErrPage">
                <el-divider direction="vertical" class="nav-divider"></el-divider>
            </div>

            <div class="right-menu-item pointer">
                <el-tooltip class="" effect="dark" content="帮助文档" placement="bottom" v-matomo="{behaviorCategory: '系统功能', event: '点击',  name: '帮助中心' }">
                    <a href="https://ho734vnlan.feishu.cn/docx/RAbVdt21sosHOexybeucSjMpn3g" target="_blank">
                        <span class="icon iconfont icon-jt-bangzhuzhongxin"></span>
                    </a>
                </el-tooltip>
            </div>
            <div class="right-menu-item pointer mr10">
                <el-popover
                    placement="bottom-end"
                    popper-class="jt-theme-color"
                    title="设置背景颜色"
                    width="330"
                    trigger="click">
                    <div class="inline-block" slot="reference">
                        <el-tooltip class="" effect="dark" content="系统主题" placement="bottom">
                            <span class="icon iconfont icon-jt-huanfu"></span>
                        </el-tooltip>
                    </div>
                    <div class="set-color">
                        <div class="set-color-item" v-for="item in themColorList" :key="item.name">
                            <span :style="{backgroundColor: item.bgColor }" v-matomo="{behaviorCategory: '系统功能', event: '点击',  name: '系统主题' }" @click="setColor(item.name)"></span>
                        </div>
                    </div>
                </el-popover>
            </div>



            <template v-if="isSubAccountLogin">
                <el-dropdown class="avatar-container right-menu-item hover-effect" @command="handleClickDropdown"
                             trigger="hover">
                    <div class="avatar-wrapper">
                        <span class="popover">
                            <span class="user-name">{{name}}（子账号）</span>
                            <i class="el-icon-caret-bottom"/>
                        </span>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="subLogout">退出子账号</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </template>
            <template v-else>
                <div class="right-menu-icon-wrap inline-block mr20" v-if="is_admin&&!isErrPage">
                    <!--<el-link @click="showSubAccount">进入成员系统</el-link>-->
                    <el-tooltip class="" effect="dark" content="进入成员系统" placement="bottom">
                        <span class="iconfont icon-jt-members pointer" @click="showSubAccount"></span>
                    </el-tooltip>
                </div>
                <el-dropdown class="avatar-container right-menu-item hover-effect" @command="handleClickDropdown"
                             trigger="hover">
                    <div class="avatar-wrapper">
                        <span class="pointer">
                            <span class="user-name">{{name}}</span>
                            <!--<span class="ml4" v-if="is_admin">[{{is_super_admin?'超':'管'}}]</span>-->
                            <i class="el-icon-caret-bottom"/>
                        </span>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="profile">个人中心</el-dropdown-item>
                        <el-dropdown-item command="pageConfig">个性化配置</el-dropdown-item>
                        <el-dropdown-item command="auc">授权中心</el-dropdown-item>
                        <el-dropdown-item command="password">修改密码</el-dropdown-item>
                        <el-dropdown-item command="logout" divided>
                            <span style="display:block;">退出登录</span>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </template>

        </div>
        <ProfileModal ref="profileModal" @bind-wx="showBindWXModal"/>
        <PasswordModal ref="passwordModal"/>
        <BindWx ref="binkWXModal" />
        <ToSubModal ref="toSubModal" />
        <DownloadModal ref="downloadModal" v-if="!isErrPage"/>

        <MessageDrawer ref="messageDrawer" @close="getMessageCount" @open="removeMessage"/>
        <ImNotify ref="imNotify" :list="notifyList" @center="toMessageCenter" @close="closeNotify" @open="openMessage"/>
        <MessageModal ref="messageModal" :msg="activeMsg" @read="setRead"/>
        <!-- 工单提交任务列表 -->
        <WorkOrderTask />
    </div>
</template>

<script>
    import dayjs from 'dayjs';
    import {mapGetters, mapMutations} from 'vuex'
    import Breadcrumb from '@/components/Breadcrumb';
    import Hamburger from '@/components/Hamburger';
    import ProfileModal from './modal/profile';
    import PasswordModal from './modal/password';
    import ToSubModal from './modal/toSubModal';
    import DownloadModal from './modal/downloadModal';
    import ImNotify from './modal/ImNotify';
    import WorkOrderTask from './modal/workOrderTask';
    import MessageModal from './modal/messageModal';
    import BindWx from './modal/bindWX';
    import API from '@/api/home';
    import UMCAPI from '@/api/umc';
    import {removeToken,removeIsLogin} from '@/utils/auth';
    import {resetRouter} from '@/router';
    import Cookies from 'js-cookie';
    import MessageDrawer from './drawer/messageDrawer';
    import {colorList} from '@/constant/index.js';
    import { workOrderQueueModal,undistributedTipModal,pageConfigModal } from './modal'
    import matomo from '@/utils/matomo.js'
    export default {
        components: {
            Breadcrumb,
            Hamburger,
            ProfileModal,
            PasswordModal,
            BindWx,
            ToSubModal,
            DownloadModal,
            MessageDrawer,
            ImNotify,
            MessageModal,
            WorkOrderTask
        },
        data(){
          return {
              isSubAccountLogin:false,
              messageCount:0,
              wsTimer:null,
              wsSwitch:false,
              ws:null,
              notifyList:[],        // 实时消息列表
              activeMsg:{},
          }
        },
        computed: {
            ...mapGetters([
                'sidebar',
                'name',
                'is_bind_wx',
                'is_sub_account',
                'is_admin',
                'is_super_admin',
                'umc_token',
                'show_queue_modal'
            ]),
            headers(){
                return {
                    headers:{
                        authorization:this.umc_token,
                    }
                }
            },
            themColorList(){
                return colorList||[];
            },
            isErrPage(){
                let $routeName = this.$route.name;
                return $routeName == 'contact'||$routeName == '404';
            },
        },
        created(){

            let isShownBindModal = window.tdIsBindWX;
            if(isShownBindModal){
                this.showBindWXModal();
                window.tdIsBindWX = null;
            }

            if(!this.isErrPage){
                this.getMessageCount();
                this.initWebSocket();
            }
        },
        mounted(){
            this.isSubAccountLogin = this.is_sub_account;
            if(!this.isErrPage){
                this.getUnreadList();
            }

            let needLoginSuccessModal = localStorage.getItem("needLoginSuccessModal");
            if(needLoginSuccessModal==='true'){
                localStorage.removeItem("needLoginSuccessModal");
                // 账户运营负责人维护 弹窗
                setTimeout(()=>{
                    this.getUndistributedAccount();
                },1000)
            }
        },
        watch:{
            is_sub_account(newVal){
                this.isSubAccountLogin = newVal;
            },
            show_queue_modal(n) {
                if (n) {
                    this.seeWorkOrderQueueModal(n)
                }
            },
        },
        methods: {
            ...mapMutations('workOrder', [
                'SET_SHOW_QUEUE_MODAL'
            ]),
            // 查看工单队列
            seeWorkOrderQueueModal(ids = '') {
                workOrderQueueModal({
                    props: {
                        is_admin: this.is_admin,
                        ids 
                    },
                    on: {
                        closed: ()=> {
                            this.SET_SHOW_QUEUE_MODAL('')
                            matomo.trackEvent('系统功能', '点击', '处理队列(关闭)');
                        }
                    }
                })
            },
            initWebSocket(){
                let curHost = window.location.host;
                let umcHost = '';
                if(curHost.includes('wankacn.com')){
                    umcHost = 'wss://umc.wankacn.com/websocket';
                }else if(window.location.protocol=='https:'){
                    umcHost = 'wss://umc.gm825.net/websocket';
                }else{
                    umcHost = 'ws://umc.gm825.net/websocket';
                }

                if (!'WebSocket' in window) {
                    return console.error('您的浏览器不支持WebSocket');
                }
                if(!this.umc_token) return;
                this.ws = new WebSocket(umcHost+'?authorization='+this.umc_token);
                if(!this.ws) return;
                this.ws.onmessage = this.websocketOnMessage;
                this.ws.onopen = ()=>{
                    // console.info('websocket连接成功');
                    this.aliveWebSocket();
                };
                this.ws.onerror = (e)=>{
                    // console.log('重连开关', wsSwitch);
                    console.log('数据传输发生错误', e);
                    // 打开重连
                    this.reconnect();
                };
                this.ws.onclose = ()=> {
                    // console.info('websocket关闭');
                    this.reconnect();
                };
            },
            getUnreadList(){
                UMCAPI.getMessageList({
                    msg_type_id:'0',        // 消息类型 0-全部 1-任务 2-预警 3-提醒 4-公告
                    read:'0',    // 是否已读 0未读 1已读 2全部
                    page:1,     // 分页 默认1
                    limit:10,
                },this.headers).then(res=>{
                    let resData = res.data||{};
                    let list = resData.list||[];
                    let notifyList = this.notifyList||[];

                    list.forEach(item=>{
                        let actionMsg = notifyList.find(inner=>inner.msg_id==item.msg_id);
                        if(!actionMsg){
                            this.notifyList.push({
                                created_at:dayjs(item.created_at*1000).format('YYYY-MM-DD HH:mm:ss'),
                                is_read:item.is_read,
                                message:item.message,
                                msg_id:item.msg_id,
                                msg_type_id:item.msg_type_id,
                                title:item.title,
                            });
                        }
                    });

                },err=>{
                    console.log('umc getMessageList err',err);
                })
            },
            reconnect(){
                // console.log('重连开关', this.wsSwitch);
                // 判断是否主动关闭连接
                if (this.wsSwitch)  return;
                // 重连定时器-每次websocket错误方法onerror触发他都会触发
                this.wsTimer && clearTimeout(this.wsTimer);
                this.aliveTimer && clearTimeout(this.aliveTimer);
                this.wsTimer = setTimeout(()=>{
                    console.log('执行断线重连...');
                    this.initWebSocket();
                    this.wsSwitch = false
                }, 2000)
            },
            aliveWebSocket(){
                this.aliveTimer && clearTimeout(this.aliveTimer);
                this.aliveTimer = setInterval(()=>{
                    this.ws.send('ok');
                },1000*60)
            },
            websocketOnMessage(e){
                let wsDataStr = e.data||'{}';
                let wsData = JSON.parse(wsDataStr);
                let resData = wsData.data;
                let list = (resData.list||[]).reverse();
                list.forEach(item=>{
                    item.created_at = dayjs(item.created_at*1000).format('YYYY-MM-DD HH:mm:ss');
                    this.notifyList.unshift({...item});
                });
                let countList = resData.count||[];
                let total = 0;
                countList.forEach(item=>{
                    total = total + (item.count||0);
                });
                if(total>0){
                    this.messageCount = total;
                }
            },
            toggleSideBar() {
                this.$store.dispatch('app/toggleSideBar')
            },
            async logout() {
                Cookies.remove('bindWxAction'+this.name);
                API.logout()
                    .then(res => {
                        console.log('logout ',res);
                        let resData = res.data||{};

                        this.$store.commit('user/SET_TOKEN', '');
                        this.$store.commit('user/SET_ROLES', '');
                        this.$store.commit('user/LOG_OUT');
                        this.$store.commit('permission/CLEAR_ROUTES');
                        removeToken();
                        removeIsLogin();
                        resetRouter();
                        this.$message.success(res.info || '操作成功');

                        if(resData.login_url){
                            window.location.href = resData.login_url;
                        }
                        // this.$router.push(`/login?redirect=${this.$route.fullPath}`);

                        /*退出成功
                        *   commit('SET_TOKEN', '')
                            commit('SET_ROLES', [])
                            removeToken()
                            resetRouter()
                            dispatch('tagsView/delAllViews', null, { root: true })
                        * */
                    }, err => {
                        console.log('>>>logout error:', err, this);
                        this.$message.error(err.info || '请求失败');
                    });
            },
            handleClickDropdown(val) {
                if (val === 'logout') {
                    this.logout();
                    matomo.trackEvent('系统功能', '点击', '退出登录');
                } else if (val === 'profile') {
                    this.$refs.profileModal.showModal();
                    matomo.trackEvent('系统功能', '点击', '个人中心');
                } else if(val === 'auc'){
                    let curHost = window.location.host;
                    let aucHost = curHost.includes('wankacn.com')?'https://auc.wankacn.com/':'https://auc.gm825.net/';
                    window.open(aucHost+'dashboard');
                    matomo.trackEvent('系统功能', '点击', '授权中心');
                }else if (val === 'password') {
                    let curHost = window.location.host;
                    let aucHost = curHost.includes('wankacn.com')?'https://auc.wankacn.com/':'https://auc.gm825.net/';
                    window.open(aucHost+'dashboard?changePsw=true');
                    matomo.trackEvent('系统功能', '点击', '修改密码');
                }else if(val == 'subLogout'){
                    matomo.trackEvent('系统功能', '点击', '退出登录');
                    if(window.name){
                        this.$message.success('退出成功，页面即将关闭！');
                        Cookies.remove('bindWxAction'+this.name);
                        setTimeout(function(){
                            window.close();
                        },2000);
                    }else{
                        let homeRoute = this.$router.options.routes.find(item => item.name === 'home');
                        let homePath = this.$router.options.base + (homeRoute ? homeRoute.path.replace(/^\//, '') : '');
                        this.$message.success('退出成功，页面即将刷新！');
                        setTimeout(function(){
                            window.location.href = window.location.origin+homePath;
                        },2000);
                    }
                }else if(val == 'pageConfig'){
                    pageConfigModal({
                            props: {},
                            cbs: {
                                onClose: (data)=> {
                                    console.log('onClose',data);
                                },
                            }
                        })
                    matomo.trackEvent('系统功能', '点击', '个性化配置');
                }
            },
            showBindWXModal(){
            },
            showSubAccount(){
                this.$refs.toSubModal.showModal();
            },
            showDownloadPage(){
                this.$refs.downloadModal.showModal();
            },
            getMessageCount(){
                UMCAPI.getMessageCount({},this.headers).then(res=>{
                    let resData = res.data||{};
                    let list = resData.list||[];
                    let total = 0;
                    list.forEach(item=>{
                        total = total + (item.count||0);
                    });
                    this.messageCount = total;
                },err=>{
                    console.log('umc getMessageCount err',err);
                })
            },
            showMessageDrawer(){
                this.$refs.messageDrawer.showDrawer();
            },
            setColor(val){
                this.$emit('set-color',val);
            },
            toMessageCenter(){
                this.closeNotify();
                this.showMessageDrawer();
            },
            closeNotify(){
                this.notifyList = [];
            },
            openMessage(msg){
                this.activeMsg = {...msg};
                if(msg.msg_type_id!='3'){
                    this.$refs.messageModal.showModal();
                }else{
                    let $html = new DOMParser().parseFromString(msg.message, 'text/html');
                    let $msgDesc = $html.querySelector('.msg-desc');
                    if(!$msgDesc) return this.$message.error('消息打开失败');
                    let taskType = $msgDesc.getAttribute("data-type");
                    if(taskType=='pop_notification'){
                        this.$refs.messageModal.showModal();
                    }else{
                        this.setRead(msg);
                    }
                }
                let index = this.notifyList.findIndex(item=>item.msg_id==msg.msg_id);
                if(index!==-1){
                    this.notifyList.splice(index,1);
                }
            },
            removeMessage(msg){
                /* 仅消掉某条消息，不展示消息的modal框 */
                let index = this.notifyList.findIndex(item=>item.msg_id==msg.msg_id);
                if(index!==-1){
                    this.notifyList.splice(index,1);
                }
            },
            setRead(msg){
                UMCAPI.markRead({
                    msg_id:msg.msg_id,
                },this.headers).then(res=>{
                    this.getMessageCount();
                },err=>{
                    console.log('umc markRead err',err);
                });
            },
            getUndistributedAccount(){
                /* 刘俊楠：这个版本里边系统强提醒中媒体账户未分配负责人的功能，先去掉（注释或者其他方式）不上线。2025.4.27 */
                return false;
                API.getUndistributedAccount().then(res=>{
                    console.log('getUndistributedAccount',res);
                    let resData = res.data||{};
                    let limit_second = resData.limit_second||0;
                    let accountData = resData.undistributed_account||{};
                    let list = accountData.data||[];
                    if(list.length>0){
                        undistributedTipModal({
                            props: {
                                limit:limit_second,
                                desc:accountData.title,
                                list:list,
                                hideClose:true,
                                cancelButtonText:'下次维护',
                                confirmButtonText:'立即维护',
                                customClass:'z-index-3000',
                                tag:'account',
                            },
                            cbs: {
                                onClose: (data)=> {
                                    console.log('onClose',data);
                                },
                                onConfirm:(data)=>{
                                    console.log('onConfirm',data);

                                    let allList = [];
                                    list.forEach(item=>{
                                        let children = item.child||[];
                                        children.forEach(inner=>{
                                            if(!allList.find(k=>k.id==inner.id)){
                                                allList.push({...inner});
                                            }
                                        })
                                    });

                                    console.log(666,allList);

                                    let curRoute = this.$route;
                                    if(curRoute.name=='bind_media_account'){
                                        // 当前就在媒体绑定页面，通过state触发搜索
                                        this.$store.commit('mediaAccount/SET_QUERY_ACCOUNT', allList);
                                    }else{
                                        this.$router.push({
                                            name:'bind_media_account',
                                            params:{
                                                list:allList,
                                            },
                                        });
                                    }
                                },
                            }
                        })
                    }
                },err=>{
                    console.log('getUndistributedAccount err',err);
                })
            },
        },
        beforeDestroy() {
            if(this.isSubAccountLogin){
                Cookies.remove('bindWxAction'+this.name);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .navbar {
        height: 50px;
        overflow: hidden;
        position: relative;
        background: #fff;
        box-shadow: 0 1px 4px rgba(0, 21, 41, .2);
        z-index: 2;

        .nav-divider{
            background-color: #c5c5c5;
            width: 2px;
        }

        .hamburger-container {
            line-height: 46px;
            height: 100%;
            float: left;
            cursor: pointer;
            transition: background .3s;
            -webkit-tap-highlight-color: transparent;

            &:hover {
                background: rgba(0, 0, 0, .025)
            }
        }

        .breadcrumb-container {
            float: left;
        }

        .errLog-container {
            display: inline-block;
            vertical-align: top;
        }

        .right-menu {
            float: right;
            height: 100%;
            line-height: 50px;

            .right-menu-icon-wrap{
                vertical-align: text-bottom;
                height: 100%;
            }

            &:focus {
                outline: none;
            }

            .right-menu-item {
                display: inline-block;
                padding: 0 8px;
                height: 100%;
                font-size: 14px;
                /*color: #5a5e66;*/
                vertical-align: text-bottom;
                /*margin-right: 12px;*/

                &.hover-effect {
                    cursor: pointer;
                    transition: background .3s;

                    &:hover {
                        background: rgba(0, 0, 0, .025)
                    }
                }
            }
            .content-center {
                display: inline-flex;
                align-items: center;
            }
            .avatar-container {
                margin-right: 30px;

                .avatar-wrapper {
                    position: relative;

                    .user-avatar {
                        cursor: pointer;
                        width: 40px;
                        height: 40px;
                        border-radius: 10px;
                    }

                    .el-icon-caret-bottom {
                        cursor: pointer;
                        position: absolute;
                        right: -20px;
                        top: 20px;
                        font-size: 12px;
                    }
                }
            }
        }
        ::v-deep .badge-con .el-badge__content{
            top: 16px;
            right: 8px;
        }
    }

    .sys-info-list{
        ul{
            list-style: inside;
        }
        li{
            line-height: 26px;
            .sys-info-text:hover{
                color: #409eff;
            }
            .num-text{
                right: 20px;
            }
        }
    }
</style>

<style lang="scss">
    .jt-theme-color {
        .set-color{
            width: 300px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            .set-color-item{
                width: 30px;
                height: 30px;
                margin: 5px;
                cursor: pointer;
                span{
                    display: inline-block;
                    width: 30px;
                    height: 30px;
                    border-radius: 30px;
                    cursor: pointer;
                    border: 1px solid #bcbcbc;
                }
            }
        }
    }
</style>
